import { css as r, LitElement as e, html as t } from "lit";
import { customElement as s } from "lit/decorators.js";
import { b as a } from "./styles-scZ6dVz-.js";
var y = Object.getOwnPropertyDescriptor, l = (u, h, k, m) => {
  for (var o = m > 1 ? void 0 : m ? y(h, k) : h, d = u.length - 1, g; d >= 0; d--)
    (g = u[d]) && (o = g(o) || o);
  return o;
};
let n = class extends e {
  render() {
    return t`
      <table>
        <slot></slot>
      </table>
    `;
  }
};
n.styles = [
  a,
  r`
      :host {
        display: block;
        width: 100%;
        overflow-x: auto;
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-md);
        background-color: var(--r5-bg);
      }

      table {
        width: 100%;
        border-collapse: collapse;
        text-align: left;
        font-size: var(--r5-text-sm);
      }
    `
];
n = l([
  s("ark-table")
], n);
let b = class extends e {
  render() {
    return t`<slot></slot>`;
  }
};
b.styles = [
  a,
  r`
      :host {
        display: table-header-group;
        background-color: var(--r5-bg-subtle);
      }
    `
];
b = l([
  s("ark-thead")
], b);
let c = class extends e {
  render() {
    return t`<slot></slot>`;
  }
};
c.styles = [
  a,
  r`
      :host {
        display: table-row-group;
      }
    `
];
c = l([
  s("ark-tbody")
], c);
let i = class extends e {
  render() {
    return t`<slot></slot>`;
  }
};
i.styles = [
  a,
  r`
      :host {
        display: table-row;
        border-bottom: 1px solid var(--r5-border);
        transition: background-color var(--r5-duration-fast);
      }

      :host(:last-child) {
        border-bottom: none;
      }

      :host(:hover) {
        background-color: var(--r5-bg-hover);
      }
    `
];
i = l([
  s("ark-tr")
], i);
let p = class extends e {
  render() {
    return t`<slot></slot>`;
  }
};
p.styles = [
  a,
  r`
      :host {
        display: table-cell;
        padding: var(--r5-space-3) var(--r5-space-4);
        font-weight: var(--r5-font-medium);
        color: var(--r5-text-muted);
        vertical-align: middle;
      }
    `
];
p = l([
  s("ark-th")
], p);
let v = class extends e {
  render() {
    return t`<slot></slot>`;
  }
};
v.styles = [
  a,
  r`
      :host {
        display: table-cell;
        padding: var(--r5-space-3) var(--r5-space-4);
        color: var(--r5-text);
        vertical-align: middle;
      }
    `
];
v = l([
  s("ark-td")
], v);
export {
  n as A,
  b as a,
  c as b,
  i as c,
  p as d,
  v as e
};
//# sourceMappingURL=ark-table-BilNMiwA.js.map
